export default class ProgressTracker {

    constructor() {
        this._chunks = [];
        this._lastPoint = 0;
        this._lastChunk = { start: 0 };
    }

    chunks() {
        return this._chunks;
    }

    push(point) {
        if (pointsAreConsecutivelyNear(this._lastPoint, point)) {
            this._lastChunk.end = point;
            if (!this._chunks.includes(this._lastChunk)) {
                this._chunks.push(this._lastChunk);
            }
        } else {
            this._lastChunk = { start: point };
        }
        this._lastPoint = point;
    }
}

export const PROGRESS_STEP = 10; // seconds
const MAX_PLAYBACK_RATE = 2;

const pointsAreConsecutivelyNear = (one, other) => {
    if (one === null || other === null) {
        return false;
    }
    if (one > other) {
        return false;
    }
    return (Math.floor(other - one) <= MAX_PLAYBACK_RATE * PROGRESS_STEP);
};



// WEBPACK FOOTER //
// ./src/utils/progress-tracker.js